import { render } from "./ConversationInputMessage.vue?vue&type=template&id=081b407d&scoped=true"
import script from "./ConversationInputMessage.vue?vue&type=script&lang=js"
export * from "./ConversationInputMessage.vue?vue&type=script&lang=js"

import "./ConversationInputMessage.vue?vue&type=style&index=0&id=081b407d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081b407d"]])

export default __exports__